<template>
    <Box :title="'资产修改('+Total+'台)'" :SearchParams="IsSee" @SearchParams="IsSee=true">
        <LoadingFooter
            v-model="loading"
            :finished="finished"
            @load="onLoad"
            @scroll="IsSee=false"
        >
            <div class="items" v-for="item in list" @click="$router.push({name: 'PropertyDetails', params: {item,pageState:pageState} })">
                <div>
                    <img src="@/assets/img/Icon_1.png"/>
                    <div>
                        <p class="ellipsis">{{item.EquName}}</p>
                        <div>
                            <div>
                                <p>资产编号：</p>
                                <p>规格型号：</p>
                                <p>使用科室：</p>
                            </div>
                            <div>
                                <p class="ellipsis">{{item.EquCode}}</p>
                                <p class="ellipsis">{{item.EquType}}</p>
                                <p class="ellipsis">{{item.DepartmentName}}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div v-if="QX" @click.stop="$router.push({name: 'PropertyEditDefault', params: {item}})">修改</div>
                    </div>
                </div>
                <div>
                    <span>启用日期</span>
                    <span>{{item.StartDate}}</span>
                </div>
            </div>
        </LoadingFooter>
        <transition name="fade">
            <div class="menu" key='1' v-show="IsSee">
                <Field title="资产名称" placeholder="请输入编号或者名称" @onMessage="value => search.SB = value"/>
                <Field title="使用科室" placeholder="请输入使用科室名称" @onMessage="value => search.KS = value"/>
                <Field title="开始时间" placeholder="请选择" type="calendar" @onMessage="value => search.QSRQ = value"/>
                <Field title="结束时间" placeholder="请选择" type="calendar" @onMessage="value => search.JSRQ = value"/>
                <div class="search" @click="serach">查询</div>
            </div>
             </transition>
    </Box>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import Field from '../../components/field/field'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'PropertyEditList',
        data() {
            return {
                QX:(this.$UserInfo.QX).toString().indexOf(',45')!==-1,
                search: {
                    SB: '',
                    KS: '',
                    QSRQ: '',
                    JSRQ: ''
                },
                IsSee:false,
                touchStartY:0,
                Total:0,
                loading: true,
                finished: false,
                list:[],
                page:1,
                pageState:false,
            }
        },
        components: {
            Box,
            Field,
            LoadingFooter
        },
        activated(){
            this.IsSee=false;
            this.page=1;
            this.list=[];
            this.loadDataDefault();
        },
        methods: {
            serach() {
                this.list=[];
                this.IsSee=false;
                this.page=1;
                this.loadDataDefault();
            },
            onLoad() {
               if (!this.loading && !this.finished) {
                   this.page += 1;
                   this.loadDataDefault();
               }
            },loadDataDefault(){
                this.$post('api/Repair/PropertyQueryForAPP',{
                    QSRQ:this.search.QSRQ,
                    JSRQ:this.search.JSRQ,
                    SB:this.search.SB,
                    KS:this.search.KS,
                    User:this.$UserInfo.UserId,
                    Store:this.$UserInfo.StoreCode,
                    PageIndex:this.page,
                    PageSize:10,
                    IsUse:'',
                    }).then(result=>{
                       this.Total = result.TotalCount;
                       for(let i=0;i<result.PropertyList.length;i++){
                           this.list.push(result.PropertyList[i]);
                       }
                       if (this.page*10 >= this.Total) {
                           this.loading = false;
                           this.finished = true;
                       }else {
                           this.loading=false;
                           this.finished=false;
                       }
                 })
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu{
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 29px 35px 40px;
        box-sizing: border-box;
        margin-bottom: 20px;
        .items{
            display: flex;
            height: 112px;
            align-items: center;
            border-bottom: 2px solid #F3F3F3;
            span{
                flex: 1;
            }
            input{
                width: 215px;
                font-size: 29px;
                text-align: center;
                &::-webkit-input-placeholder{
                    color: #858585;
                }
            }
        }
        .search{
            height: 88px;
            background: $THEME-COLOR;
            border-radius: 8px;
            font-size: 32px;
            color: $TEXT-LIGHT-COLOR;
            text-align: center;
            line-height: 88px;
            margin-top: 35px;
        }
    }
    .items{
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding-bottom: 20px;
        &>div{
            &:first-child{
                display: flex;
                padding: 34px 16px 27px 26px;
                box-sizing: border-box;
                border-bottom: 2px solid #EFEFEF;
                img {
                    width: 150px;
                    height: 150px;
                    border-radius: 4px;
                }
                &>div {
                    &:nth-child(2){
                        margin-left: 16px;
                        &>p {
                            color: $TEXT-DARK-COLOR;
                            font-weight: bold;
                            font-size: 32px;
                            margin-bottom: 18px;
                            width: 330px;
                            display: flex;
                        }
                        &>div{
                            display: flex;
                            p{
                                color: #999;
                                font-size: 26px;
                                line-height: 45px;
                                height: 45px;
                            }
                            &>div{
                                &:last-child{
                                    p{
                                        width: 170px;
                                    }
                                }
                            }
                        }
                    }
                    &:last-child{
                        &>div{
                            &:first-child{
                                color: $TEXT-DARK-COLOR;
                                font-size: 26px;
                                display: flex;
                                justify-content: center;
                                span{
                                    margin-left: 70px;
                                }
                                img{
                                    width: 32px;
                                    height: 32px;
                                }
                            }
                            &:last-child{
                                margin-left: 25px;
                                width: 152px;
                                height: 61px;
                                background: $THEME-COLOR;
                                border-radius: 30px;
                                text-align: center;
                                line-height: 61px;
                                font-size: 26px;
                                color: $TEXT-LIGHT-COLOR;
                                margin-top: 62px;
                            }
                        }
                    }
                }
            }
            &:last-child{
                margin-top: 16px;
                padding: 0 26px 0 31px;
                box-sizing: border-box;
                display: flex;
                span{
                    color: #999;
                    font-size: 26px;
                    &:first-child {
                        flex: 1
                    }
                }
            }
        }
    }
    .listLength{
        font-size: 29px;
        color: #4a4a4a;
        margin-bottom: 18px;
        margin-left: 30px;
        span{
            margin-left: 20px;
            color: $THEME-COLOR;
            font-weight: bold;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/propertyEditList/propertyEditList.vue